import React, { useState, useRef, useEffect } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiTableSearch from "../../controls/MuiTableSearch";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Import AntD
import { Modal } from "antd";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import from genderSlice.js
import {
  addGenderToServer,
  getGendersFromServer,
  updateGenderInserver,
  deleteGenderFromServer,
  getGendersCountFromServer,
  getGendersFromServerByPagination,
} from "./genderSlice";

import "./gender.css";

const Gender = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const signInUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signInUser);
  const [visiblePaper, setVisiblePaper] = useState(false);
  const [genderId, setGenderId] = useState(0);
  const [genderCode, setGenderCode] = useState("");
  const [genderName, setGenderName] = useState("");
  const [buttonSave, setButtonSave] = useState("Save");
  const [gendersList, setGendersList] = useState([]);
  const [originalGendersList, setOriginalGendersList] = useState([]);
  const [gendersCount, setGendersCount] = useState(0);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // const [preventTableDataRendering, setPreventTableDataRendering] =
  //   useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //End useState

  //useRef
  const genderCodeRef = useRef(null);
  const genderNameRef = useRef(null);
  const saveRef = useState(null);
  const cancelRef = useState(null);
  const clearRef = useState(null);
  //End useRef

  const fetchDatasByPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getGendersFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
      }
      if (Array.isArray(unwrappedResult.data))
        setGendersList(unwrappedResult.data);
    } catch (err) {
      console.log({ ErrorOccured: err });
      setNotify({
        isOpen: true,
        message: err.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => setLoginUser(result.data));
    }

    const fetchDatas = async () => {
      try {
        const gendersListResult = await dispatch(getGendersFromServer());
        const unwrappedResult = unwrapResult(gendersListResult);
        if (unwrappedResult.data.length > 0)
          setOriginalGendersList(unwrappedResult.data);

        const gendersCountResult = await dispatch(getGendersCountFromServer());
        const unwrappedGendersCountResult = unwrapResult(gendersCountResult);
        unwrappedGendersCountResult.data[0].GendersCount === undefined
          ? setGendersCount(0)
          : setGendersCount(unwrappedGendersCountResult.data[0].GendersCount);
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };

    // dispatch(getGendersFromServer())
    //   .then(unwrapResult)
    //   .then((result) => {
    //     if (result.data.length > 0) {
    //       setGendersList(result.data);
    //       setOriginalGendersList(result.data);
    //     } else {
    //       setNotify({
    //         isOpen: true,
    //         message: result.message,
    //         severity: "warning",
    //       });
    //     }
    //   })
    //   .catch((err) => console.log({ objError: err }));

    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);

  useEffect(() => {
    fetchDatasByPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleAdd = (e) => {
    e.preventDefault();
    setVisiblePaper(true);
    resetfields();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    let trimmedGenderCode = genderCode.trim();
    let trimmedGenderName = genderName.trim();
    if (trimmedGenderCode === "") {
      setNotify({
        isOpen: true,
        message: "Gender Code is required",
        severity: "warning",
      });
      genderCodeRef.current.focus();
      return;
    } else if (trimmedGenderName === "") {
      setNotify({
        isOpen: true,
        message: "Gender Name is required",
        severity: "warning",
      });
      genderNameRef.current.focus();
      return;
    } else {
      const newGender = {
        genderCode: trimmedGenderCode,
        genderName: trimmedGenderName,
        loginUser,
      };
      await dispatch(addGenderToServer(newGender))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else if (result.flag === 2) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "warning",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });

      await dispatch(getGendersCountFromServer())
        .then(unwrapResult)
        .then((result) => {
          setGendersCount(result.data[0].GendersCount);
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });
      await fetchDatasByPagination(page + 1, rowsPerPage);
      resetfields();
      genderCodeRef.current.focus();
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetfields();
    setVisiblePaper(false);
    setButtonSave("Save");
  };

  const handleClear = (e) => {
    e.preventDefault();
    resetfields();
    genderCodeRef.current.focus();
  };

  const resetfields = () => {
    setGenderId(0);
    setGenderCode("");
    setGenderName("");
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    { id: "Id", label: "Id", minWidth: 170 },
    { id: "GCode", label: "Code", minWidth: 170 },
    { id: "GName", label: "Name", minWidth: 100 },
  ];

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleEdit = (gender) => {
    setVisiblePaper(true);
    setGenderId(gender.Id);
    setGenderCode(gender.GCode);
    setGenderName(gender.GName);
    visiblePaper ? genderCodeRef.current.focus() : setVisiblePaper(true);
    setButtonSave("Update");
  };

  const handleUpdate = async () => {
    let trimmedGenderCode = genderCode.trim();
    let trimmedGenderName = genderName.trim();
    if (trimmedGenderCode === "") {
      setNotify({
        isOpen: true,
        message: "Gender Code is required",
        severity: "warning",
      });
      genderCodeRef.current.focus();
      return;
    } else if (trimmedGenderName === "") {
      setNotify({
        isOpen: true,
        message: "Gender Name is required",
        severity: "warning",
      });
      genderNameRef.current.focus();
      return;
    } else {
      let updatedGender = {
        genderCode: trimmedGenderCode,
        genderName: trimmedGenderName,
        loginUser,
      };
      await dispatch(updateGenderInserver({ ...updatedGender, genderId }))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else if (result.flag === 2) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "warning",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });

      await fetchDatasByPagination(page + 1, rowsPerPage);

      resetfields();
      genderCodeRef.current.focus();
      setButtonSave("Save");
    }
  };

  const handleDelete = (genderId) => {
    resetfields();
    setButtonSave("Save");
    confirm({
      title: "Are you sure to delete this gender?",
      // content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        await dispatch(deleteGenderFromServer({ genderId, loginUser }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });

              // Important
              // If gendersCount = 21
              // newTotalRecords = 21-1 => 20
              // totalPages = (20/10) => 2
              // currentPage = 3
              // Condition "true" => currentPage = 2

              // If gendersCount = 22
              // newTotalRecords = 22-1 => 21
              // totalPages = (21/10) => Reminder(1) So it is 3
              // currentPage = 3
              // Condition "false" => currentPage = 3

              // const newTotalRecords = gendersCount - 1;
              // const totalPages = Math.ceil(newTotalRecords / pageSize);
              // if (currentPage > totalPages) {
              //   setCurrentPage(totalPages);
              // }
              // dispatch(
              //   getGendersFromServerByPagination({
              //     pageNo: currentPage > totalPages ? totalPages : currentPage,
              //     rowSize: pageSize,
              //   })
              // )
              //   .then(unwrapResult)
              //   .then((result) => {
              //     setPaginatedDataSource(result.data);
              //   })
              //   .catch((err) => console.log({ objError: err }));

              // dispatch(getGendersCountFromServer())
              //   .then(unwrapResult)
              //   .then((result) => setGendersCount(result.data[0].GendersCount))
              //   .catch((err) => console.log({ objError: err }));
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getGendersCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setGendersCount(result.data[0].GendersCount);
          })
          .catch((err) => console.log({ objError: err }));

        // .finally(() => setPreventTableDataRendering(false));
        let currentPage = parseInt(page + 1);
        const newTotalRecords = gendersCount - 1;
        const totalPages = Math.ceil(newTotalRecords / rowsPerPage); // rowcount
        if (currentPage > totalPages) {
          setPage(Math.max(totalPages - 1, 0)); // Ensures the page is at least 0
          await fetchDatasByPagination(page, rowsPerPage);
        } else {
          await fetchDatasByPagination(page + 1, rowsPerPage);
        }
        visiblePaper ? genderCodeRef.current.focus() : setVisiblePaper(false);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasByPagination(page + 1, rowsPerPage);
    } else {
      const filteredRows = originalGendersList.filter((gender) => {
        return (
          gender.GName.toLowerCase().includes(searchedVal.toLowerCase()) ||
          gender.GCode.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setGendersList(filteredRows);
    }
  };

  return (
    <>
      <Box className="genderboxcontainer">
        <Alert notify={notify} setNotify={setNotify} />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: "5px" }}
        >
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdd}
              sx={{ mb: "5px" }}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleRefresh}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Refresh
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", mt: "-13px" }}
          >
            <MuiTableSearch
              placeholder="Search Gender"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
        </Grid>

        {visiblePaper ? (
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            <h6>Add Gender</h6>
            <Divider />
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="gendercode"
                    label="Gender Code *"
                    onChange={(e) => {
                      setGenderCode(e.target.value);
                    }}
                    value={genderCode}
                    inputRef={genderCodeRef}
                    autoComplete="off"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="gendername"
                    label="Gender Name *"
                    onChange={(e) => {
                      setGenderName(e.target.value);
                    }}
                    value={genderName}
                    inputRef={genderNameRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        genderCodeRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  {buttonSave === "Save" ? (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnsave"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          genderNameRef.current.focus();
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnupdate"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          genderNameRef.current.focus();
                      }}
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    className="btncancel"
                    variant="contained"
                    size="small"
                    ref={cancelRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        saveRef.current.focus();
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    variant="contained"
                    size="small"
                    className="btnclear"
                    ref={clearRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        cancelRef.current.focus();
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        ) : (
          ""
        )}
      </Box>

      <Box
        className="genderboxcontainer"
        sx={visiblePaper ? { mt: 3 } : { mt: 0 }}
      >
        <Paper elevation={2} sx={{ p: 2 }}>
          <TableContainer sx={{ maxHeight: 1000 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      hidden={column.id === "Id" ? true : false}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {gendersList.length > 0 ? (
                  gendersList.map((gender) => (
                    <TableRow key={gender.Id}>
                      <TableCell>
                        <EditIcon
                          className="editicon"
                          fontSize="medium"
                          onClick={() => handleEdit(gender)}
                        />
                        <DeleteIcon
                          className="deleteicon"
                          fontSize="medium"
                          onClick={() => handleDelete(gender.Id)}
                        />
                      </TableCell>
                      <TableCell hidden={true}>{gender.Id}</TableCell>
                      <TableCell>{gender.GCode}</TableCell>
                      <TableCell>{gender.GName}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Genders found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className="MuiTablePagination-selectLabel"
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={gendersCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};

export default Gender;
